import { useSuspenseQuery } from "@apollo/client";
import {
    TripBuilderDraftOrderWithFlightOffersDocument,
    TripBuilderDraftOrderWithFlightOffersQuery,
    TripBuilderDraftOrderWithFlightOffersQueryVariables,
} from "../../../../generated/graphql";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";

export const useTripsWithOffers = () => {
    const { draftQuote } = useTripBuilderQuote();

    const result = useSuspenseQuery<
        TripBuilderDraftOrderWithFlightOffersQuery,
        TripBuilderDraftOrderWithFlightOffersQueryVariables
    >(TripBuilderDraftOrderWithFlightOffersDocument, {
        variables: {
            id: draftQuote?._id ?? "",
        },
        context: { fetchOptions: { cache: "no-store" } },
    });
    if (result.data.draftOrder?.__typename !== "DraftOrder") {
        throw new Error("No draftOrder found");
    }
    if (result.data.draftOrder.order.__typename !== "Quote") {
        throw new Error("No Order found");
    }
    return result.data.draftOrder.order.trips;
};
